<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["producerEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="producer" ref="formProducer" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Producer Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="producer.name" maxlength="30"></el-input>
                </el-form-item>      

                <!-- Producer LastName -->    
                <el-form-item :label="i18nValues['lastName']" prop="lastName"> 
                  <el-input v-model="producer.lastName" maxlength="30"></el-input>
                </el-form-item>  

                <!-- Producer Mail -->    
                <el-form-item :label="i18nValues['mail']" prop="mail"> 
                  <el-input v-model="producer.mail" maxlength="30"></el-input>
                </el-form-item> 

                <div></div>

                <!-- Producer Number -->    
                <el-form-item :label="i18nValues['number']" prop="number">
                  <el-input v-model="producer.number" type="text" maxlength="30" @input="validateNumber"></el-input>
                </el-form-item>

                <!-- Producer BusinessName -->    
                <el-form-item :label="i18nValues['businessName']" prop="businessName"> 
                  <el-input v-model="producer.businessName" maxlength="30"></el-input>
                </el-form-item> 
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "ProducerEdition",  
  
    created(){
  
      if(this.id != 0 ){
          this.retrieveById();
      } else{
        this.producer.creationUser = this.user.name;
        this.producer.creationDate = new Date();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        lastName:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        mail:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        number:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
        businessName:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  
    },
  
    components: {
      
    },
  
    computed: {
      loading: get("producer/loading"),
    },
  
    props:["id"],
  
    data() {
      return {
  
        producer: {},
  
      rules:{},
      returnQuery: {},
  
      };
    },
  
    methods: {
      save(){
        this.$refs["formProducer"].validate(valid => {
          if(valid){
            this.$store.dispatch("producer/saveProducer", this.producer).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["producerSaved"],
                      position: "bottom-right",
                  });      
                  this.$router.push({name:"ProducerAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["producerSaveError"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"ProducerAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("producer/retrieveProducerById", { id: this.id }).then((res)=>{
              this.producer = res;
              this.producer.modificationUser = this.user.name;
              this.producer.modificationDate = new Date();
          });       
      },

      validateNumber() {
        //this.producer.number = this.producer.number.replace(/\D/g, '');
        this.producer.number = this.producer.number.replace(/[^\d+]/g, '');
      }
    },
  
  
  }
  </script>
  
  <style>
  
  </style>